import React from 'react';
import classnames from 'classnames';
import { compact } from 'lodash';

import { DetailedPricingPlanFragment } from '../../../../graphql.schema';
import PricingPanel from '../../PricingPanel';
import StrapiLink from '../../StrapiLink/StrapiLink';
import { RichTextField } from '../../RichTextField/RichTextField';

import * as styles from './StrapiDetailedPricingPlan.module.scss';

export const StrapiDetailedPricingPlan = ({
  title,
  description,
  links,
  deliveryMethod,
}: DetailedPricingPlanFragment) => {
  return (
    <div className={styles.root}>
      <div className={classnames('content', styles.column)}>
        <h2 className="title is-2">{title}</h2>
        <RichTextField content={description} />
        {compact(links).map((link, i) => (
          <StrapiLink key={`detailed-pricing-plan-link-${i}`} {...link} />
        ))}
      </div>
      <div className={styles.column}>
        <div className={styles.pricingPlanPanel}>
          {deliveryMethod ? <PricingPanel {...deliveryMethod} showFeatures /> : null}
          <div className={styles.pricingBackground} />
        </div>
      </div>
    </div>
  );
};
